module.exports = __webpack_public_path__ + "img/Last image OOBE Japanese.3cfc016d.png";